module.exports = __webpack_public_path__ + "img/yellowcheckersm2.84aebb20.png";